import { Divider, Grid, Tab, Tabs, Theme, useMediaQuery } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { Button, CreateButton, ExportButton, TopToolbar, useDataProvider, useRefresh } from "react-admin";
import { PbhRequestStatusListTab, PbhRequestStatus } from "../../../../Enums/PbhRequestStatus";
import "./style.css";
import classnames from "classnames";
import { useStyles } from "../RequestOrderList/styles";
import { SourcePbhRequestOrder } from "../../Constant/Source";
import { useAccessControl, useAuth, useVerifyPermission } from "@airborne/react-admin";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import {
  DefaultFilterArray,
  DetailFilterArray,
  pbhLocalRepairExportColumn,
  pbhOpenRequestExportColumn,
  pbhRejectionProposalExportColumn,
  pbhReservedExportColumn,
  pbhShippingProcessExportColumn,
  pbhSuspendedExportColumn,
  pbhUnshippedSvcExportColumn,
  pbhWaitingPoolScopeExportColumn,
} from "./pbhRequestList.constants";
import FilterToolbar from "../../../../Components/FiltersToolbar/FilterToolbar";
import PbhRequestOrderDataGrid from "./DataGrid/PbhRequestOrderDataGrid";
import RequestRemark from "./Notes/RequestRemark";
import { RemarkTypes } from "../../../../Enums/RemarkTypes";
import { SetUpSignalRConnection } from "../../../../Helper/SignalRConnection";
import { HttpTransportType } from "@microsoft/signalr";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";
import { CustomPbhRequestListFilterEnum } from "../../../../../src/Enums/CustomPbhRequestListFilterEnum";
import { formatDate } from "../../../../Helper/MomentHelper";

const PBH_REQUEST_FILTER_DEFAULT_VALUES = {
  requestStatus__eq: PbhRequestStatus.Open,
  customFilter__eq: CustomPbhRequestListFilterEnum.ThirdParty,
};

const PbhListActions = React.memo((props: any) => {
  const { activeTab, ...raProps } = props;
  const { user } = useAuth();
  const { canCreate } = useAccessControl(SourcePbhRequestOrder);

  return (
    <TopToolbar {...raProps}>
      {user?.isCustomer && canCreate && (
        <CreateButton basePath={raProps.basePath} icon={raProps.icon} label={raProps.label} />
      )}
      <Button
        label="Clear Filters"
        onClick={() => {
          const customFilter = raProps.filterValues?.customFilter__eq || CustomPbhRequestListFilterEnum.ThirdParty;

          if (activeTab === PbhRequestStatus.UnshippedSvc) {
            raProps.setFilters({
              requestStatus__in: [
                PbhRequestStatus.UnshippedSvc,
                PbhRequestStatus.AlternatePnOffered,
                PbhRequestStatus.AlternatePnAccepted,
                PbhRequestStatus.AlternatePnRejected,
              ],
              customFilter__eq: customFilter,
            });
          } else if (activeTab === PbhRequestStatus.WaitingPoolScope) {
            raProps.setFilters({
              requestStatus__eq: activeTab,
              customFilter__eq: customFilter,
              [`!(access = false && repair = true) || (isLocalRepair = true)`]: "test",
            });
          } else {
            raProps.setFilters({
              requestStatus__eq: activeTab,
              customFilter__eq: customFilter,
            });
          }
        }}
      />
      <ExportButton
        resource={raProps.resource}
        sort={raProps.currentSort}
        filterValues={raProps.filterValues}
        maxResults={10000}
      />
    </TopToolbar>
  );
});

const PbhDetailFilter = React.memo((props: any) => {
  const { activeTab, ...rest } = props;
  return (
    <FilterToolbar
      dataSource={
        activeTab === PbhRequestStatus.WaitingPoolScope || activeTab === PbhRequestStatus.Open
          ? DetailFilterArray
          : DetailFilterArray.filter(f => f.source !== "isLocalRepair")
      }
    />
  );
});

const PbhListChild = React.memo((props: any) => <PbhRequestOrderDataGrid {...props} />);

export const PbhRequestList = (props: any) => {
  useVerifyPermission("customroutes", "pbhrequestorders.list.read");
  const { tokens, user } = useAuth();
  const [activeTab, setActiveTab] = useState(PbhRequestStatus.Open);
  const [tabs, setTabs] = useState<any[]>([...PbhRequestStatusListTab(user?.isCustomer)]);
  const [requestRemark, setRequestRemark] = useState<any>({});
  const [isMatchCreate, setIsMatchCreate] = useState(false);
  const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("xs"));
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // activeTab değiştiğinde filtreleri uygula — filter mantığı PbhRequestOrderDataGrid içinde
  // React.useEffect(() => {
  //   SetUpSignalRConnection(
  //     "hub/eventhub",
  //     HttpTransportType.ServerSentEvents | HttpTransportType.WebSockets,
  //     tokens?.accessToken || "",
  //     false
  //   ).then(con => {
  //     con.on("PbhOrderCreate", data => {
  //       if (activeTab === PbhRequestStatus.Open) {
  //         refresh();
  //       }
  //     });
  //   });
  // }, []);

  useEffect(() => {
    getTabs();
  }, []);
  const getTabs = useCallback(() => {
    dataProvider
      .getList("pbhrequeststatusinfo/reference", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "id", order: "ASC" },
        filter: {
          [`id =  ${PbhRequestStatus.WaitingPoolScope} || 
          id =  ${PbhRequestStatus.Open} || 
          id =  ${PbhRequestStatus.UnshippedSvc} || 
          id =  ${PbhRequestStatus.Reserved} || 
          id =  ${PbhRequestStatus.ShippingProcess} || 
          id =  ${PbhRequestStatus.RejectionProposal} ||
          id =  ${PbhRequestStatus.AlternatePnOffered} ||
          id =  ${PbhRequestStatus.AlternatePnAccepted} ||
          id =  ${PbhRequestStatus.AlternatePnRejected} ||
          id =  ${PbhRequestStatus.LocalRepair} ||
          id =  ${PbhRequestStatus.Suspended} 
          `]: "test",
        },
      })
      .then(response => {
        var filteredData = [] as any;
        var totalAlternateCount = 0;

        response.data.forEach(item => {
          if (
            item.id == PbhRequestStatus.AlternatePnOffered ||
            item.id == PbhRequestStatus.AlternatePnAccepted ||
            item.id == PbhRequestStatus.AlternatePnRejected
          ) {
            totalAlternateCount += item.totalCount;
          } else {
            filteredData.push(item);
          }
        });

        const request = filteredData.find(element => element.id === PbhRequestStatus.UnshippedSvc);
        if (request) {
          request.totalCount = request.totalCount + totalAlternateCount;
        }

        let tabList = filteredData.map(item => ({
          value: item.id,
          label: item.displayName,
          count: item.totalCount,
          reloadTabs: getTabs,
        }));
        setTabs(tabList);
      })
      .catch(error => {
        console.log(error);
      });
  }, [dataProvider]);

  const onCreateRemarks = useCallback((record: any) => {
    setIsMatchCreate(true);
    setRequestRemark(record);
  }, []);

  const PbhDefaultRequestFilter = props => <FilterToolbar dataSource={DefaultFilterArray} />;
  const handleCloseRemark = () => {
    // getTabs();
    refresh();
  };
  const getNotes = async idList => {
    var response = await dataProvider.getList("PbhRequestRemarks", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "ASC" },
      filter: {
        requestId__in: idList,
        remarkType__eq: RemarkTypes.PbhNote,
      },
    });
    return response?.data ?? [];
  };
  const ExportToExcel = async (records, fetchRelatedRecords) => {
    var notesResponse = await getNotes(records.map(x => x.id));
    var columns: any = [];
    var data: any = [];
    switch (activeTab) {
      case PbhRequestStatus.Open:
        columns = [...pbhOpenRequestExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            v.pn,
            v.isPool ? true : false,
            v.airportCode,
            v.acRegistration,
            formatDate(v.createdDate),
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(v.requestedDeliveryDate),
            notesResponse
              .filter(x => x.requestId == v.id)
              .map(x => x.remark)
              .join(", "),
          ]),
        ];
        break;
      case PbhRequestStatus.WaitingPoolScope:
        columns = [...pbhWaitingPoolScopeExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            v.pn,
            v.airportCode,
            v.acRegistration,
            formatDate(v.createdDate),
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(v.requestedDeliveryDate),
            notesResponse
              .filter(x => x.requestId == v.id)
              .map(x => x.remark)
              .join(", "),
          ]),
        ];
        break;
      case PbhRequestStatus.UnshippedSvc:
        var statusList: any = [];
        for (var enumValue in PbhRequestStatus) {
          if (isNaN(Number(enumValue))) {
            var result = enumValue?.replace?.(/([A-Z])/g, " $1");
            var finalResult = result?.charAt?.(0)?.toUpperCase?.() + result?.slice?.(1);
            statusList.push({
              Value: Number(PbhRequestStatus[enumValue]),
              Description: finalResult || enumValue,
            });
          }
        }
        columns = [...pbhUnshippedSvcExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            statusList.find(x => x.Value == v.requestStatus)?.Description ?? "",
            v.pn,
            v.pnDescription,
            v.airportCode,
            v.acRegistration,
            formatDate(v.createdDate),
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(v.requestedDeliveryDate),
            v.displayWhCount,
            v.displayResCount,
            v.displayAltPnCount,
            // v.displayWoCount,
            // v.displayRoCount,
            // v.displayPoExCount,
            v.displayRnCount,
            v.advancedXo,
            v.currentPbhNote,
          ]),
        ];
        break;
      case PbhRequestStatus.Reserved:
        columns = [...pbhReservedExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            v.pn,
            v.pnDescription,
            v.airportCode,
            v.acRegistration,
            formatDate(v.createdDate),
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(v.requestedDeliveryDate),
            v.displayWhCount,
            v.displayResCount,
            v.displayAltPnCount,
            // v.displayWoCount,
            // v.displayRoCount,
            // v.displayPoExCount,
            v.displayRnCount,
            v.advancedXo,
            notesResponse
              .filter(x => x.requestId == v.id)
              .map(x => x.remark)
              .join(", "),
          ]),
        ];
        break;
      case PbhRequestStatus.ShippingProcess:
        columns = [...pbhShippingProcessExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            v.pn,
            v.pnDescription,
            v.airportCode,
            v.acRegistration,
            formatDate(v.createdDate),
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(v.requestedDeliveryDate),
            v.displayWhCount,
            v.displayResCount,
            v.displayAltPnCount,
            // v.displayWoCount,
            // v.displayRoCount,
            // v.displayPoExCount,
            v.displayRnCount,
            notesResponse
              .filter(x => x.requestId == v.id)
              .map(x => x.remark)
              .join(", "),
          ]),
        ];
        break;
      case PbhRequestStatus.RejectionProposal:
        var statusList: any = [];
        for (var enumValue in PbhRequestStatus) {
          if (isNaN(Number(enumValue))) {
            var result = enumValue?.replace?.(/([A-Z])/g, " $1");
            var finalResult = result?.charAt?.(0)?.toUpperCase?.() + result?.slice?.(1);
            statusList.push({
              Value: Number(PbhRequestStatus[enumValue]),
              Description: finalResult || enumValue,
            });
          }
        }
        columns = [...pbhRejectionProposalExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            statusList.find(x => x.Value == v.requestStatus)?.Description ?? "",
            v.pn,
            v.pnDescription,
            v.airportCode,
            v.acRegistration,
            v.createdDate,
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : v.requestedDeliveryDate == new Date("01/01/9999")
                ? "Exclude"
                : v.requestedDeliveryDate,
            v.displayWhCount,
            v.displayResCount,
            v.displayAltPnCount,
            // v.displayWoCount,
            // v.displayRoCount,
            // v.displayPoExCount,
            v.displayRnCount,
            v.currentPbhNote,
            v.pbhReservedNotes,
          ]),
        ];
        break;
      case PbhRequestStatus.LocalRepair:
        var statusList: any = [];
        for (var enumValue in PbhRequestStatus) {
          if (isNaN(Number(enumValue))) {
            var result = enumValue?.replace?.(/([A-Z])/g, " $1");
            var finalResult = result?.charAt?.(0)?.toUpperCase?.() + result?.slice?.(1);
            statusList.push({
              Value: Number(PbhRequestStatus[enumValue]),
              Description: finalResult || enumValue,
            });
          }
        }
        columns = [...pbhLocalRepairExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            statusList.find(x => x.Value == v.requestStatus)?.Description ?? "",
            v.pn,
            v.pnDescription,
            v.airportCode,
            v.acRegistration,
            formatDate(v.createdDate),
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(v.requestedDeliveryDate),
            v.advancedXo,
            v.currentPbhNote,
          ]),
        ];
        break;
      case PbhRequestStatus.Suspended:
        var statusList: any = [];
        for (var enumValue in PbhRequestStatus) {
          if (isNaN(Number(enumValue))) {
            var result = enumValue?.replace?.(/([A-Z])/g, " $1");
            var finalResult = result?.charAt?.(0)?.toUpperCase?.() + result?.slice?.(1);
            statusList.push({
              Value: Number(PbhRequestStatus[enumValue]),
              Description: finalResult || enumValue,
            });
          }
        }
        columns = [...pbhSuspendedExportColumn];
        data = [
          ...records.map(v => [
            v.refNo,
            v.customerName,
            v.requirementCategoryText,
            statusList.find(x => x.Value == v.requestStatus)?.Description ?? "",
            v.pn,
            v.pnDescription,
            v.airportCode,
            v.acRegistration,
            formatDate(v.createdDate),
            v.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(v.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(v.requestedDeliveryDate),
            v.displayWhCount,
            v.displayResCount,
            v.displayAltPnCount,
            // v.displayWoCount,
            // v.displayRoCount,
            // v.displayPoExCount,
            v.displayRnCount,
            v.advancedXo,
            v.currentPbhNote,
          ]),
        ];
        break;
    }
    ExcelExport(columns, data, "Pbh Request List");
  };
  return (
    <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.13, overflow: "auto" }}>
      <Tabs
        style={{ width: "100%" }}
        variant={"fullWidth"}
        centered
        value={activeTab}
        indicatorColor="primary"
        onChange={handleChange}
        className={classnames({
          [classes.listWithDrawer]: isMatchCreate,
        })}
      >
        {tabs.map((tab: any) => {
          return <Tab key={tab.value + "tab"} label={`${tab.label} (${tab.count ?? 0})`} value={tab.value} />;
        })}
      </Tabs>

      <div style={{ maxWidth: window.innerWidth - window.innerWidth * 0.15, overflow: "auto" }}>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <PoolList
              {...props}
              id="pbh-request-list"
              emptyWhileLoading={true}
              resource={SourcePbhRequestOrder}
              basePath={SourcePbhRequestOrder}
              className={classnames(classes.list, { [classes.listWithDrawer]: isMatchCreate })}
              title={"Request Order List"}
              filterDefaultValues={PBH_REQUEST_FILTER_DEFAULT_VALUES}
              actions={<PbhListActions activeTab={activeTab} />}
              sort={{ field: "createdDate", order: "DESC" }}
              exporter={ExportToExcel}
              filters={<PbhDetailFilter activeTab={activeTab} />}
            >
              <PbhListChild
                setActiveTab={setActiveTab}
                requestStatus={activeTab}
                onCreateRemarks={onCreateRemarks}
                reloadTabs={getTabs}
                isXSmall={isXSmall}
              />
            </PoolList>
          </Grid>
        </Grid>
        <Divider />
        <RequestRemark
          isMatchCreate={isMatchCreate}
          setIsMatchCreate={setIsMatchCreate}
          requestRemark={requestRemark}
          handleClose={handleCloseRemark}
          // onSuccess={() => {
          //   refresh();
          // }}
        />
      </div>
    </div>
  );
};
export default PbhRequestList;
